import { render, staticRenderFns } from "./FollowersItem.vue?vue&type=template&id=7127647b&scoped=true&"
import script from "./FollowersItem.vue?vue&type=script&lang=ts&"
export * from "./FollowersItem.vue?vue&type=script&lang=ts&"
import style0 from "./FollowersItem.vue?vue&type=style&index=0&id=7127647b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7127647b",
  null
  
)

export default component.exports